module.exports = __webpack_public_path__ + "static/media/mission@3x.daec92f5.png";